import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePageHeader } from '../providers/PageHeaderProvider';
import { useUser } from '../providers/UserProvider';

const PAGE_TITLES: Record<string, string> = {
    '/account': 'Account'
};

const WelcomeBanner: React.FC = () => {
    const { user, isLoading } = useUser();
    const { title: pageHeaderTitle, subtitle: pageHeaderSubtitle } = usePageHeader();
    const location = useLocation();

    if (pageHeaderTitle) {
        return (
            <div className="flex items-baseline gap-2.5">
                <h2 className="text-2xl font-bold text-gray-800">{pageHeaderTitle}</h2>
                {pageHeaderSubtitle && (
                    <span className="text-sm text-gray-500">{pageHeaderSubtitle}</span>
                )}
            </div>
        );
    }

    const pageTitle = PAGE_TITLES[location.pathname];

    if (pageTitle) {
        return <h2 className="text-2xl font-bold text-gray-800">{pageTitle}</h2>;
    }

    const welcomeName = user?.name || 'there';

    return (
        <h2 className="text-2xl font-bold text-gray-800">
            {isLoading ? 'Loading...' : `Welcome back, ${welcomeName}`}
        </h2>
    );
};

export default WelcomeBanner;
